import type { Member } from "@smartsuite/automation-engine-api";
import { makeAutoObservable } from "mobx";

export class MembersStore {
  list: Member[] = [];
  pageSize: number = 20;

  constructor() {
    makeAutoObservable(this);
  }

  setList(members: Member[]): void {
    this.list = members;
  }
}
